(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-tab"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.pf-slider-next, .pf-slider-prev');
    if (!button) return;
    var wrap = button.closest('.fNRLzJ, [class*="pf-89"], .description');
    var slider = wrap && wrap.querySelector('.pf-slider');
    if (!slider) return;
    event.preventDefault();
    var amount = Math.round(slider.clientWidth * 0.8);
    slider.scrollBy({
      left: button.classList.contains('pf-slider-prev') ? -amount : amount,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
